export default __webpack_public_path__ + "static/1.1_FR-fc34abc94c796aedbe588633c4902d77.webp";